<template>
  <div class="media align-items-center">
    <div
      class="media-left"
      data-container="body"
      data-toggle="popover"
      data-trigger="hover"
      data-placement="top"
      data-content="Turning the agent experience on will make Support Center feel as if you are an agent browsing it: you will only see what agents can see."
    >
      <toggle-button v-model="show" @change="onToggle"></toggle-button>
    </div>
    <div class="media-body small ml-3">
      Agent experience is <b>{{ show ? 'On' : 'Off' }}</b>
    </div>
  </div>
</template>

<style scoped>
label {
  margin-bottom: 0;
}
</style>

<script>
import { ToggleButton } from 'vue-js-toggle-button'
import { toggleSupportShowAgentExperience } from '@/api'
import $ from 'jquery'

export default {
  components: {
    ToggleButton
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      show: this.value
    }
  },
  mounted () {
    //
  },
  methods: {
    async onToggle () {
      const { data } = await toggleSupportShowAgentExperience()
      this.show = data.showAgentExperience
      this.$nextTick(() => {
        $('html, body').animate({
          scrollTop: 0
        })
        document.location.reload()
      })
    }
  }
}
</script>
